import React, { useEffect, useState } from "react";
import Cities from "../Cities.json";
import { LoadingButton } from "@mui/lab";
import {
	Box,
	Dialog,
	Typography,
	Button,
	FormControl,
	FormLabel,
	TextareaAutosize,
	TextField,
	Select,
	MenuItem,
} from "@mui/material";
import AlertMsg from "../component/AlertMsg";

function EditAdvisorModal({
	open,
	setOpen,
	editAdvisorApi,
	idToEdit,
	advisor,
	editMsg,
	setEditMsg,
}) {
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		mobile: "",
		mail: "",
		gender: "",
		capacity: 0,
		bio: "",
		link: "",
		city: "",
		psychologicBio: "",
	});

	const handleInputChange = e => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
	};

	const submitButtonHandler = async () => {
		setLoading(true);
		await editAdvisorApi(formData, idToEdit);
		setLoading(false);
	};

	const inputs = [
		{ id: "firstName", label: "نام", type: "text" },
		{ id: "lastName", label: "نام خانوادگی", type: "text" },
		{ id: "mobile", label: "تلفن همراه", type: "number" },
		{
			id: "gender",
			label: "جنسیت",
			type: "select",
			options: [
				{ value: 1, label: "مرد" },
				{ value: 0, label: "زن" },
			],
		},
		{
			id: "city",
			label: "شهر",
			type: "select",
			options: Cities.map(city => ({ value: city, label: city })),
		},
		{ id: "mail", label: "پست الکترونیکی", type: "email" },
		{ id: "link", label: "لینک ارتباطی", type: "text" },
		{ id: "capacity", label: "ظرفیت تعداد دانش آموز", type: "number" },
		{ id: "bio", label: "توضیحات درباره مشاور", type: "textarea" },
		{
			id: "psychologicBio",
			label: "توضیحات درباره مشاوره روانشناسی",
			type: "textarea",
		},
	];

	useEffect(() => {
		setFormData(advisor);
	}, [advisor]);

	return (
		<Dialog
			fullWidth
			open={open}
			onClose={() => {
				setOpen(false);
				setEditMsg(null);
			}}>
			<Box p={2}>
				<Typography fontSize={18} fontWeight={"bold"} mb={2}>
					ویرایش مشاور
				</Typography>
				{inputs.map(input => (
					<FormControl key={input.id} fullWidth margin="normal">
						<FormLabel sx={{ fontWeight: "bold", mb: 0.2 }}>{input.label}</FormLabel>
						{input.type === "textarea" ? (
							<TextareaAutosize
								onChange={handleInputChange}
								name={input.id}
								placeholder={input.label}
								value={formData[input.id] || ""}
								minRows={3}
								style={{ fontFamily: "Iran Sans", padding: "7px" }}
							/>
						) : input.type === "select" ? (
							<Select
								onChange={handleInputChange}
								name={input.id}
								value={formData[input.id] || ""}>
								{input.options.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						) : (
							<TextField
								name={input.id}
								value={formData[input.id]}
								onChange={handleInputChange}
								placeholder={input.label}
								type={input.type}
							/>
						)}
					</FormControl>
				))}
				<LoadingButton
					variant="contained"
					color="secondary"
					onClick={loading ? undefined : submitButtonHandler}
					sx={{ fontSize: "16px", color: "white", my: 1 }}
					loading={loading}>
					ویرایش
				</LoadingButton>
				<Button
					variant="contained"
					sx={{ fontSize: "16px", mr: 2, my: 1 }}
					onClick={() => {
						setOpen(false);
						setEditMsg(null);
					}}>
					انصراف
				</Button>

				{editMsg ? (
					editMsg.type ? (
						<AlertMsg message={editMsg} type={"success"} />
					) : (
						<AlertMsg message={editMsg} type={"error"} />
					)
				) : null}
			</Box>
		</Dialog>
	);
}

export default EditAdvisorModal;
